import { Grid } from "@mui/material";
import React, { useState } from "react";
import Proposals from "./Proposals";
import TopicsFeed from "./TopicsFeed";
import EventsCard from "./EventsCard";
import AgentStoriesCard from "./AgentStoriesCard";

function Dashboard() {
    const [agentStoriesShow, setAgentStoriesShow] = useState(true);

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                    <Proposals />
                </Grid>
                <Grid item xs={12} md={8}>
                    <TopicsFeed />
                </Grid>
                <Grid item xs={12} md={agentStoriesShow ? 8 : 12}>
                    <EventsCard />
                </Grid>
                {agentStoriesShow && (
                    <Grid item xs={12} md={4}>
                        <AgentStoriesCard setAgentStoriesShow={setAgentStoriesShow} />
                    </Grid>
                )}
            </Grid>
        </div>
    );
}

export { Dashboard };
